import React from "react";
import { Heart, Users, Stethoscope } from "lucide-react";

const DirectorSection = () => {
  return (
    <section id="director" className="director-bg relative overflow-hidden" data-testid="director-section">
      <div className="container-hc py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Photo */}
          <div className="lg:col-span-5 relative">
            <div
              className="relative rounded-[28px] overflow-hidden shadow-2xl border-[3px] border-white aspect-[4/5]"
              role="img"
              aria-label="Jana Pate, Executive Director"
              data-testid="director-photo"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/bjwrglub_IMG_2711.jpeg"
                alt="Jana Pate, Executive Director"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>

            {/* Floating experience badge */}
            <div
              className="absolute -bottom-5 -right-3 sm:-right-6 bg-[color:var(--hc-navy)] text-white rounded-2xl px-6 py-5 shadow-2xl"
              data-testid="experience-badge"
            >
              <div className="text-[10px] font-bold tracking-[0.22em] text-[#a8c8e8]">
                EXPERIENCE
              </div>
              <div className="mt-1 font-serif-display text-3xl">
                <span className="text-white">15</span>{" "}
                <span className="text-[#c4d8ec] italic">years</span>
              </div>
              <div className="text-xs text-white/70">of nursing excellence</div>
            </div>
          </div>

          {/* Bio */}
          <div className="lg:col-span-7">
            <div className="hc-chip chip-light" data-testid="director-chip">
              <span className="w-2 h-2 rounded-full bg-[color:var(--hc-coral)] pulse-dot" />
              Meet Our Director
            </div>

            <h2 className="font-serif-display mt-6 text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-[color:var(--hc-navy)]">
              Jana <span className="italic text-[color:var(--hc-coral)]">Pate</span>
            </h2>
            <div className="mt-3 text-xs font-bold tracking-[0.32em] text-[color:var(--hc-navy)]/60">
              EXECUTIVE DIRECTOR
            </div>

            <div className="mt-7 space-y-5 text-lg text-[color:var(--hc-navy)]/80 leading-relaxed max-w-2xl">
              <p>
                With <strong className="text-[color:var(--hc-navy)]">15 years of nursing experience</strong>,
                Jana brings clinical excellence, compassionate leadership, and a true servant's
                heart to our residents and families. She has spent her career caring for others
                and advocating for older adults with integrity and dedication.
              </p>
              <p>
                Jana is deeply invested in our community — serving as a board member for{" "}
                <strong className="text-[color:var(--hc-navy)]">Adult Protective Services</strong>,
                the <strong className="text-[color:var(--hc-navy)]">Burke and Angelina County
                Senior Citizen Center</strong> (which serves Meals on Wheels to San Augustine
                residents), and continuously working to strengthen the support systems that
                serve our most vulnerable neighbors.
              </p>
              <p>
                Her passion for people, commitment to quality care, and strong community roots
                make her an incredible addition to the Hillcrest family.
              </p>
            </div>

            <div className="mt-8 space-y-3 max-w-xl">
              {[
                { icon: Stethoscope, color: "var(--hc-coral)", label: "Clinical Excellence" },
                { icon: Users, color: "#a8c8e8", label: "Community Leader" },
                { icon: Heart, color: "#5fb6d3", label: "Servant's Heart" },
              ].map((q) => (
                <div
                  key={q.label}
                  className="flex items-center gap-4 bg-white rounded-2xl px-5 py-3.5 shadow-sm border border-black/5"
                  data-testid={`quality-${q.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <span
                    className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                    style={{ background: q.color }}
                  />
                  <span className="font-semibold text-[color:var(--hc-navy)]">{q.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DirectorSection;
